import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/** Sales channels IMS can push inventory to. */
// Not a DB enum: admin RPC channel list that only overlaps user_session_platform by coincidence. //redontIgnore
export const InventoryPushChannelSchema = z.enum(["shopify", "amazon"]);
export type InventoryPushChannel = z.infer<typeof InventoryPushChannelSchema>;

export const getInventoryPushSettings = {
  name: "getInventoryPushSettings" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    channels: z.array(
      z.object({
        channel: InventoryPushChannelSchema,
        /** Whether the team has an enabled integration for this channel. */
        connected: z.boolean(),
        enabled: z.boolean(),
      }),
    ),
  }),
};
